export enum EnumSubtipoPerfil {
  Estandar = 1,
  Manual = 2,
  Historico = 3
}
